import script from "./InstagramFeeds.vue?vue&type=script&setup=true&lang=js"
export * from "./InstagramFeeds.vue?vue&type=script&setup=true&lang=js"

import "./InstagramFeeds.vue?vue&type=style&index=0&id=1647fb5e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1647fb5e"]])

export default __exports__